// @ts-nocheck
import { faEllipsisH, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/base/Button";
import { currencyFormat } from "helpers/utils";
import { Dropdown, Badge } from "react-bootstrap";
import DealCardCompact from "components/cards/DealCardCompact";
import { Draggable } from "react-beautiful-dnd";
import { dealsAtom } from "jotai/LeadsJotaiInstance";
import { useAtom } from "jotai";
import { useState } from "react";
import axiosInstance from "helpers/api";
import toast from "react-hot-toast";
import ConfirmDeleteModal from "../common-components/ConfirmDeleteModal";

const DealColumnCompact = ({ column, handleOpenAddModal }: any) => {
  const [deals, setDeals] = useAtom(dealsAtom);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);

  const handleShowDeleteModal = (id: any) => {
    setShowDeleteModal(true);
    setSelectedLeadId(id);
  };

  const handleDeleteStage = async (id: any) => {
    try {
      const response = await axiosInstance.delete(`/deals/deal-stages/${id}`);
      toast.success(response.data.message);
      const filterDeals = deals.filter((item: any) => item.id !== id);
      setDeals(filterDeals);
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  // Calculate total value for the column
  const totalValue = column.deals?.reduce((sum: number, deal: any) => 
    sum + (parseFloat(deal.deal_price) || 0), 0
  ) || 0;

  return (
    <div 
      className="deals-column-compact"
      style={{
        background: 'white',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        padding: '12px',
        width: '320px',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 280px)', // Adjust based on your header height
        minHeight: '400px'
      }}
    >
      {/* Compact Column Header */}
      <div 
        className="column-header d-flex align-items-center justify-content-between mb-2"
        style={{
          padding: '8px 4px',
          borderBottom: '1px solid #e5e7eb',
          position: 'sticky',
          top: 0,
          background: 'white',
          zIndex: 1
        }}
      >
        <div className="d-flex align-items-center flex-grow-1">
          <h6 
            className="mb-0 me-2"
            style={{ 
              fontSize: '14px',
              fontWeight: 600,
              color: '#1f2937'
            }}
          >
            {column.deal_stage_name}
          </h6>
          <Badge 
            bg="secondary"
            style={{
              fontSize: '11px',
              padding: '2px 6px',
              borderRadius: '10px',
              background: '#e5e7eb',
              color: '#1f2937'
            }}
          >
            {column.deals?.length || 0}
          </Badge>
        </div>
        
        <div className="d-flex align-items-center gap-2">
          <span style={{ 
            fontSize: '12px',
            fontWeight: 600,
            color: '#10b981'
          }}>
            ${(totalValue / 1000).toFixed(0)}k
          </span>
          
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="link"
              className="p-0 text-muted"
              style={{ fontSize: '14px' }}
            >
              <FontAwesomeIcon icon={faEllipsisH} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item 
                onClick={() => handleOpenAddModal(column.id)}
                style={{ fontSize: '13px' }}
              >
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Add Deal
              </Dropdown.Item>
              {column.isCustom && (
                <>
                  <Dropdown.Divider />
                  <Dropdown.Item
                    className="text-danger"
                    onClick={() => handleShowDeleteModal(column.id)}
                    style={{ fontSize: '13px' }}
                  >
                    Delete Stage
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      {/* Scrollable Deal List */}
      <div 
        className="deals-list"
        style={{
          overflowY: 'auto',
          flex: 1,
          paddingTop: '4px'
        }}
      >
        {column.deals?.map((deal: any, index: number) => (
          <Draggable key={deal.id} draggableId={deal.id} index={index}>
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <DealCardCompact deal={deal} />
              </div>
            )}
          </Draggable>
        ))}
        
        {/* Empty State */}
        {(!column.deals || column.deals.length === 0) && (
          <div 
            className="text-center py-4"
            style={{
              color: '#9ca3af',
              fontSize: '13px'
            }}
          >
            <p className="mb-2">No deals in this stage</p>
            <Button
              size="sm"
              variant="link"
              onClick={() => handleOpenAddModal(column.id)}
              style={{ fontSize: '12px' }}
            >
              <FontAwesomeIcon icon={faPlus} className="me-1" />
              Add first deal
            </Button>
          </div>
        )}
      </div>

      {/* Add Deal Button at Bottom */}
      <div className="mt-2 pt-2" style={{ borderTop: '1px solid #e5e7eb' }}>
        <Button
          variant="link"
          className="w-100 text-center p-2"
          onClick={() => handleOpenAddModal(column.id)}
          style={{ 
            fontSize: '12px',
            color: '#6b7280',
            textDecoration: 'none'
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#00d4ff'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#6b7280'}
        >
          <FontAwesomeIcon icon={faPlus} className="me-1" />
          Add Deal
        </Button>
      </div>

      <ConfirmDeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={() => handleDeleteStage(selectedLeadId)}
        message="Are you sure you want to delete this stage?"
      />
    </div>
  );
};

export default DealColumnCompact;